import React from 'react';
import { Crown, Check, Wifi, WifiOff, Skull } from 'lucide-react';

const PlayerSlot = ({ player, isHost, isCurrentUser }) => {
  if (!player) {
    return (
      <div className="flex items-center gap-3 p-3 rounded-xl border border-dashed border-slate-600 bg-slate-800/20">
        <div className="w-10 h-10 rounded-full bg-slate-700/50 flex items-center justify-center">
          <span className="text-slate-500 text-lg">?</span>
        </div>
        <span className="text-slate-500 text-sm italic">En attente d'un joueur...</span>
      </div>
    );
  }

  const hasCountry = !!player.country_short_name;

  return (
    <div className={`flex items-center gap-3 p-3 rounded-xl border transition-all ${
      isCurrentUser
        ? 'border-blue-500/50 bg-blue-500/10'
        : 'border-slate-600 bg-slate-800/30'
    }`}>
      {/* Avatar / Flag */}
      <div className="w-10 h-10 rounded-full bg-slate-700 flex items-center justify-center overflow-hidden relative">
        {hasCountry ? (
          <img
            src={require(`../../assets/flags/${player.country_short_name}.png`)}
            alt={player.country_short_name}
            className="w-8 h-8 object-contain"
          />
        ) : (
          <span className="text-slate-400 text-lg font-bold">
            {player.username?.charAt(0).toUpperCase()}
          </span>
        )}
        {player.is_eliminated && (
          <div className="absolute inset-0 bg-red-900/60 flex items-center justify-center">
            <Skull className="w-5 h-5 text-red-400" />
          </div>
        )}
      </div>

      {/* Info */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className={`font-medium truncate ${isCurrentUser ? 'text-blue-300' : 'text-white'}`}>
            {player.username}
          </span>
          {isHost && <Crown className="w-4 h-4 text-yellow-400 shrink-0" />}
          {isCurrentUser && <span className="text-xs text-blue-400">(vous)</span>}
        </div>
        {hasCountry && (
          <span className="text-xs text-slate-400">{player.country_short_name}</span>
        )}
      </div>

      {/* Status indicators */}
      <div className="flex items-center gap-2">
        {player.is_connected === false && (
          <WifiOff className="w-4 h-4 text-red-400" />
        )}
        {player.is_ready && (
          <div className="w-6 h-6 rounded-full bg-green-500/20 flex items-center justify-center">
            <Check className="w-4 h-4 text-green-400" />
          </div>
        )}
      </div>
    </div>
  );
};

export default PlayerSlot;
